import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListEmspUserDidCell } from './emsp-bo-charging-session-list-emsp-user-did.cell';
import { EmspBoChargingSessionListEmspUserDidHeader } from './emsp-bo-charging-session-list-emsp-user-did.header';

export const EmspBoChargingSessionListEmspUserDidColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['emspUser']['did']
> = {
  id: 'emspUserDid',
  enableSorting: false,
  header: EmspBoChargingSessionListEmspUserDidHeader,
  cell: EmspBoChargingSessionListEmspUserDidCell,
};
